module.exports = __webpack_public_path__ + "img/sort-arrow.2a1a3b4c.svg";